export default __webpack_public_path__ + "static/media/top.7fd9ccc0.png";